module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "back",
    on: {
      "click": _vm.click
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_c('icon', {
    attrs: {
      "name": "arrow",
      "scale": 1.2
    }
  }), _vm._v("\n    " + _vm._s(_vm.text ? _vm.text : _vm.$t('general.back')) + "\n  ")], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3de42a08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/Back-v2.vue
// module id = 952
// module chunks = 0